import { AppDateTime } from '@macs-frontend/core/utils/datetime';
import {
  Contract,
  ContractStatuses,
  DimonaStatuses,
  Distance,
  User,
} from '@macs-frontend/web-macs/shared';
import { MdAction, MdBaseAction } from '@macs-frontend/web-macs/shared/models/action';
import { BaseActionPlanningDateAction } from './action-planning';
import {
  ActionTeam,
  BaseActionTeam,
  BaseCompositionRole,
  CompositionRole,
} from './action-team';
import { BaseEntity } from './base-entity.model';
import { BaseExternalUser, ExternalUser } from './external-user';
import { TCCompositionRole } from '@macs-frontend/features/company-management/team-cost/team-cost.types';

export interface BaseBookingPerson extends BaseEntity {
  lastMovementState: BookingPersonMovementState;
  nextMovementState?: BookingPersonMovementState | null;
  nextCheckInStepTitle?: string | null;
  isActionActive: boolean;
  startViaCompany: boolean;
  directToEvent: boolean;
  status: BookingPersonStatus;
  confirmationToken?: string;
  lastContractStatus?: ContractStatuses;
  available?: boolean;
  printableContractIds: number[];
  volunteered: boolean;
  startTime?: AppDateTime;
  endTime?: AppDateTime;
  startTimeUTC?: AppDateTime;
  endTimeUTC?: AppDateTime;
  isReporter: boolean;
}

export interface BookingPersonExternalUser
  extends BaseExternalUser,
    Pick<ExternalUser, 'location' | 'knowledge' | 'country' | 'phones'> {}

export interface BookingPersonCompositionRoleTeamAction
  extends MdBaseAction,
    Pick<MdAction, 'actionLocation'> {
  actionPlanningDate: BaseActionPlanningDateAction;
}

export interface BookingPersonCompositionRoleTeam
  extends BaseActionTeam,
    Pick<ActionTeam, 'scheduleStartLocations'> {
  action?: BookingPersonCompositionRoleTeamAction;
}

export interface BookingPersonCompositionRole
  extends BaseCompositionRole,
    Pick<CompositionRole, 'scheduleStartLocation'> {
  actionTeam?: BookingPersonCompositionRoleTeam;
}

export interface BookingPerson extends BaseBookingPerson {
  externalUser: BookingPersonExternalUser;
  compositionRole?: BookingPersonCompositionRole;
  tcCompositionRole?: TCCompositionRole;
  action: MdBaseAction;
  eventDistance?: Distance;
  bookedBy: User;
  dimonaStatus: DimonaStatuses | null;
  lastContract?: Pick<Contract, 'uuid' | 'signed'>;
}

export enum BookingPersonStatus {
  OPEN = 'OPEN',
  PENDING = 'PENDING',
  BOOKED = 'BOOKED',
  REJECTED = 'REJECTED',
  REJECTED_TOO_LATE = 'REJECTED_TOO_LATE',
}

export enum BookingPersonMovementState {
  None = 'none',
  Arrived = 'arrived',
  Moved = 'moved',
  Departed = 'departed',
}
